/** @module Auth0BetaOptInLocalUser */
/* eslint-disable import/extensions */
import Auth0UserSessionHelper from '../auth0-session-helper.mjs';
import Auth0BetaOptInWithUserContext from './auth0-beta-opt-in-feature-user-context-base.mjs';

class Auth0BetaOptInLocalUser extends Auth0BetaOptInWithUserContext {
  constructor(options) {
    super(options);
    console.log(`Auth0BetaOptInLocalUser init for flag => "${JSON.stringify(options)}"`);
    this._init();
  }

  optIn() {
    this._buildUserContextFromAuthState();
    if (!Auth0UserSessionHelper.isLoggedIn || !Auth0UserSessionHelper.userSellerId) {
      throw new Error(`A user must be logged in to opt in to "${this._featureId}".`);
    }
    console.log(`Auth0BetaOptInLocalUser.optIn for "${this._featureId}"`);
    this._addUserContextToPersistedState();
  }

  optOut() {
    this._buildUserContextFromAuthState();
    if (!Auth0UserSessionHelper.isLoggedIn || !Auth0UserSessionHelper.userSellerId) {
      throw new Error(`A user must be logged in to opt out of "${this._featureId}".`);
    }
    console.log(`Auth0BetaOptInLocalUser.optOut for "${this._featureId}"`);
    this._removeUserContextFromPersistedState();
  }

  isOptedIn = async () => {
    this._buildUserContextFromAuthState();
    if (!Auth0UserSessionHelper.isLoggedIn || !Auth0UserSessionHelper.userSellerId) {
      console.log(`Feature flag "${this._featureId}" evaluation is false (user not logged in)...`);
      return false;
    }

    // the list of any user who has opted into this feature in the past
    const optedInHistory = this._foundUserContextHistoryData.map(fcd => this._toUserContext(fcd.sellerId, fcd));
    console.log(`Auth0BetaOptInLocalUser optedInHistory set => ${JSON.stringify(optedInHistory)}`);
    const val = optedInHistory.some(uc => uc.key === Auth0UserSessionHelper.userSellerId);
    console.log(`Feature flag "${this._featureId}" evaluated to "${val}"...`);
    return val;
  };
}

export default Auth0BetaOptInLocalUser;
